module.exports = __webpack_public_path__ + "static/media/levelCardIcon.33bca2e0.svg";